module.exports = __webpack_public_path__ + "img/zimm-kneeling.8e58c267.png";